import React from "react";

const BlogDetailsSkeleton = () => {
  return (
    <div className="bg-gray-50 animate-pulse">
      <main className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* LEFT CONTENT */}
          <div className="lg:col-span-2">
            {/* Featured Image */}
            <div className="w-full h-64 sm:h-80 bg-gray-300 rounded-md mb-6" />

            {/* Metadata */}
            <div className="flex items-center text-sm text-gray-500 mb-4">
              <div className="w-20 h-4 bg-gray-300 rounded"></div>
              <span className="mx-2">•</span>
              <div className="flex gap-3">
                <div className="w-16 h-6 bg-gray-300 rounded-md"></div>
                <div className="w-16 h-6 bg-gray-300 rounded-md"></div>
                <div className="w-16 h-6 bg-gray-300 rounded-md"></div>
              </div>
            </div>

            {/* Title */}
            <div className="w-3/4 h-10 bg-gray-300 rounded mb-6"></div>

            {/* First few paragraphs */}
            <div className="space-y-4">
              <div className="w-full h-4 bg-gray-300 rounded"></div>
              <div className="w-5/6 h-4 bg-gray-300 rounded"></div>
              <div className="w-4/6 h-4 bg-gray-300 rounded"></div>
            </div>

            {/* Quote Block */}
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8">
              <div className="w-3/4 h-6 bg-gray-200 rounded"></div>
            </div>

            {/* Remaining paragraphs */}
            <div className="space-y-4 mb-8">
              <div className="w-full h-4 bg-gray-300 rounded"></div>
              <div className="w-5/6 h-4 bg-gray-300 rounded"></div>
              <div className="w-4/6 h-4 bg-gray-300 rounded"></div>
            </div>

            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="w-full h-48 bg-gray-300 rounded-lg"></div>
              <div className="w-full h-48 bg-gray-300 rounded-lg"></div>
              <div className="w-full h-48 bg-gray-300 rounded-lg"></div>
            </div>

            {/* Section Heading */}
            <div className="w-1/2 h-8 bg-gray-300 rounded mb-4"></div>

            {/* Section content */}
            <div className="space-y-4">
              <div className="w-full h-4 bg-gray-300 rounded"></div>
              <div className="w-5/6 h-4 bg-gray-300 rounded"></div>
              <div className="w-4/6 h-4 bg-gray-300 rounded"></div>
            </div>
          </div>

          {/* RIGHT SIDEBAR CTA CARD */}
          <div className="lg:col-span-1 sticky top-32">
            <div className="rounded-lg h-full bg-gradient-to-br from-indigo-900 to-purple-900 p-8 flex flex-col justify-center items-center text-center">
              <div className="w-40 h-10 bg-gray-400/40 rounded mb-6"></div>
              <div className="w-32 h-6 bg-gray-400/40 rounded mb-4"></div>
              <div className="w-48 h-8 bg-gray-400/40 rounded mb-8"></div>
              <div className="w-full h-12 bg-gray-400/40 rounded"></div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default BlogDetailsSkeleton;
